import clsx from "clsx"
import { ReactNode } from "react"

export type AlertProps = {
  color?: "green" | "blue" | "purple" | "brown"
  children: ReactNode
}

export const Alert = ({ color = "green", children }: AlertProps) => {
  return (
    <div
      className={clsx("w-full rounded-2xl px-6 py-8 font-light text-balance xl:py-10", {
        "bg-np-green10": color === "green",
        "bg-np-blue10": color === "blue",
        "bg-np-purple10": color === "purple",
        "bg-np-brown10": color === "brown",
      })}
    >
      {children}
    </div>
  )
}
